export const handleEditorPaste = (e, cleanData, maxCharCount, core) => {
  if (!cleanData) return cleanData;

  // Check if content has multiple lines separated by <br> or newlines
  if (cleanData.includes("<br") || cleanData.includes("\n")) {
    const selectionNode = core ? core.getSelectionNode() : null;
    const isInsideList = core && core.util && selectionNode && core.util.getParentElement(selectionNode, "LI");

    const lines = cleanData
      .split(/<br\s*\/?>|\r?\n/gi)
      .map((line) => line.trim())
      .filter((line) => line.length > 0);

    if (lines.length > 1) {
      if (isInsideList) {
        return lines.map((line) => `<li>${line}</li>`).join("");
      }
      return lines.map((line) => `<p>${line}</p>`).join("");
    }
  }
  return cleanData;
};

export const ensureContentSpacing = (html) => {
  if (!html) return html;

  let result = html
    // Preserve empty lines/paragraphs so mobile renderers do not collapse them to 0 height
    .replace(/<p><br\s*\/?><\/p>/gi, '<p style="margin: 8px 0; min-height: 14px;">&nbsp;</p>')
    .replace(/<div><br\s*\/?><\/div>/gi, '<div style="margin: 8px 0; min-height: 14px;">&nbsp;</div>');

  // Helper to add or update CSS property in an HTML tag string
  const injectStyle = (tagStr, property, value) => {
    const styleRegex = /style=(["'])(.*?)\1/i;
    const propRegex = new RegExp(`${property}\\s*:`, "i");

    if (styleRegex.test(tagStr)) {
      return tagStr.replace(styleRegex, (match, quote, styleContent) => {
        if (propRegex.test(styleContent)) {
          return match; // already has this property
        }
        const trimmed = styleContent.trim();
        const sep = trimmed && !trimmed.endsWith(";") ? "; " : (trimmed ? " " : "");
        return `style=${quote}${trimmed}${sep}${property}: ${value};${quote}`;
      });
    } else {
      return tagStr.replace(/>$/, ` style="${property}: ${value};">`);
    }
  };

  // 1. Ensure standard headings (h1-h6) have bottom and top margins
  result = result.replace(/<h([1-6])([^>]*)>/gi, (match) => {
    let tag = injectStyle(match, "margin-bottom", "14px");
    tag = injectStyle(tag, "margin-top", "10px");
    return tag;
  });

  // 2. Ensure ordered lists (<ol>) and unordered lists (<ul>) have top & bottom margins
  // This prevents lists from sticking directly to preceding text/headings on mobile renderers
  result = result.replace(/<(ol|ul)([^>]*)>/gi, (match) => {
    let tag = injectStyle(match, "margin-top", "10px");
    tag = injectStyle(tag, "margin-bottom", "10px");
    return tag;
  });

  // 3. Ensure paragraphs (<p>) have proper bottom margins
  // In rich text, users frequently create headings using bold text or colons (e.g. <p><strong>Title:</strong></p>)
  // instead of selecting H1-H6. We give heading-like paragraphs 14px and standard paragraphs 10px bottom margin.
  result = result.replace(/<p([^>]*)>([\s\S]*?)<\/p>/gi, (fullMatch, attrs, innerContent) => {
    if (/^(&nbsp;|\s|<br\s*\/?>)*$/i.test(innerContent)) {
      return fullMatch;
    }

    const hasBold = /<(strong|b)(\s+[^>]*)?>[\s\S]*?<\/\1>/i.test(innerContent);
    const endsWithColon = /:\s*(<\/[^>]+>)*\s*$/i.test(innerContent.trim());
    const isHeadingLike = hasBold || endsWithColon;

    const marginBottom = isHeadingLike ? "14px" : "10px";
    const openingTag = `<p${attrs}>`;
    const styledOpeningTag = injectStyle(openingTag, "margin-bottom", marginBottom);

    return `${styledOpeningTag}${innerContent}</p>`;
  });

  // 4. Handle direct text container <div> tags (when defaultTag is "div")
  result = result.replace(/<div([^>]*)>([\s\S]*?)<\/div>/gi, (fullMatch, attrs, innerContent) => {
    if (/^(&nbsp;|\s|<br\s*\/?>)*$/i.test(innerContent)) {
      return fullMatch;
    }
    // Skip wrapper divs that contain other block elements
    if (/<(p|div|ol|ul|table|h[1-6])\b/i.test(innerContent)) {
      return fullMatch;
    }

    const hasBold = /<(strong|b)(\s+[^>]*)?>[\s\S]*?<\/\1>/i.test(innerContent);
    const endsWithColon = /:\s*(<\/[^>]+>)*\s*$/i.test(innerContent.trim());
    const isHeadingLike = hasBold || endsWithColon;

    const marginBottom = isHeadingLike ? "14px" : "10px";
    const openingTag = `<div${attrs}>`;
    const styledOpeningTag = injectStyle(openingTag, "margin-bottom", marginBottom);

    return `${styledOpeningTag}${innerContent}</div>`;
  });

  return result;
};

export const EditorOptions = {
  defaultTag: "p",
  buttonList: [
    ["undo", "redo"],
    ["font", "fontSize", "formatBlock"],
    ["bold", "italic", "underline"],
    //["strike"],
    //["subscript", "superscript"],
    ["fontColor", "hiliteColor"],
    //["textStyle"],
    ["outdent", "indent"],
    ["align", "list", "lineHeight", "horizontalRule"],
    ["removeFormat"],
    ["link"],
    ["table"],
    "/",
    //["table", "link", "image", "video", "audio"],
    //["fullScreen", "showBlocks", "codeView"],
    //["preview", "print"]
  ],
  callBackSave: (contents) => {
    console.log("Save:", contents);
  },
};

